import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { ActivityTimeline } from './ActivityTimeline'
import type { ActivityType } from '@/types/activity'

interface ActivityDayDialogProps {
  open: boolean
  /** Дата в формате YYYY-MM-DD; null — диалог закрыт */
  date: string | null
  onClose: () => void
  userId?: number
  scope?: 'students'
  types?: ActivityType[]
  showUserName?: boolean
}

/**
 * Детализация одного дня heatmap: тот же таймлайн, ограниченный датой,
 * с постраничной подгрузкой при скролле внутри модалки.
 */
export function ActivityDayDialog({
  open,
  date,
  onClose,
  userId,
  scope,
  types,
  showUserName = false,
}: ActivityDayDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ flexGrow: 1 }}>
          {t('activity.dayTitle', {
            date: date ? dayjs(date).format('DD.MM.YYYY') : '',
          })}
        </Box>
        <IconButton onClick={onClose} size="small" aria-label={t('common.close')}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ maxHeight: '70vh' }}>
        {date && (
          <ActivityTimeline
            userId={userId}
            scope={scope}
            date={date}
            types={types}
            showUserName={showUserName}
            perPage={20}
            emptyText={t('activity.emptyDay')}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
